<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div
      class="form-element__datepicker"
      :class="{ '-half': isHalf }"
      ref="datepicker"
    ></div>
    <flat-pickr
      v-if="config"
      :class="classObject"
      :placeholder="placeholder"
      v-model="date"
      :config="config"
      @on-change="change"
      @on-close="close"
    ></flat-pickr>
    <div class="form-element__message" v-if="message">{{ message }}</div>
    <div class="form-element__message" :class="{ '-error': isError }" v-if="message2"  style="color:red" >{{ message2 }}</div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import "flatpickr/dist/flatpickr.css";
export default {
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: [Date, String],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Bir tarih seçiniz",
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    message: {
      type: String,
      default: null,
    },
    message2: {
      type: String,
      default: null
    },
    minDate: {
      type: String,
      default: null,
    },
    maxDate: {
      type: String,
      default: null,
    },
    defaultDate: {
      type: String,
      default: null,
    },
    isSecondary:{
      type: Boolean,
      default: false,
    },
    isHalfAndSecondary:{
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      date: null,
      config: null,
    };
  },
  computed: {
    classObject: function () {
      let list = {
        "-secondary": this.isSecondary,
        "-error": this.isError,
        "-half": this.isHalf,
        "-halfAndSecondary":this.isHalfAndSecondary
      };

      return list;
    },
  },
  watch: {
    value: function () {},
    date: function (val) {
      this.$emit("input", val);
      // this.val = val;
    },
  },
  created() {
    this.createCalendar();
  },
  methods: {
    createCalendar: function () {
      let vm = this;

      let config = {
        altFormat: "d F Y",
        placeholder: "",
        wrap: true,
        altInput: true,
        dateFormat: "Z",
        locale: Turkish,
        defaultDate: this.defaultDate ? this.getDate(this.defaultDate) : null,
        maxDate: this.maxDate ? this.getDate(this.maxDate) : null,
        minDate: this.minDate ? this.getDate(this.minDate) : null,
        appendTo: null,
      };

      setTimeout(() => {
        config.appendTo = this.$refs["datepicker"];
        vm.config = config;
      }, 200);

      if (vm.defaultDate) vm.date = vm.getDate(vm.defaultDate);
      // if (vm.value) vm.date = vm.value;

      return;
    },
    change: function (e) {
      return e;
    },
    close: function (e) {
      return e;
    },
    getDate: function (date) {
      let _date = date.split(",");
     
      let newdate = new Date(
        parseInt(_date[0]),
        parseInt(_date[1]),
        parseInt(_date[2])
      );
     
      return newdate;
    },
  },
};
</script>